"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AlyceDivider = exports.Divider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ramda = require("ramda");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    divider: function divider(props) {
      return {
        borderColor: props.color ? (0, _ramda.pathOr)(props.color, (0, _ramda.split)('.', props.color), palette) : palette.divider,
        margin: props.m && spacing(props.m),
        padding: props.p && spacing(props.p),
        marginTop: (props.mt || props.my) && spacing(props.mt || props.my),
        marginBottom: (props.mb || props.my) && spacing(props.mb || props.my),
        paddingTop: (props.pt || props.py) && spacing(props.pt || props.py),
        paddingBottom: (props.pb || props.py) && spacing(props.pb || props.py),
        marginLeft: (props.ml || props.mx) && spacing(props.ml || props.mx),
        marginRight: (props.mr || props.mx) && spacing(props.mr || props.mx),
        paddingLeft: (props.pl || props.px) && spacing(props.pl || props.px),
        paddingRight: (props.pr || props.px) && spacing(props.pr || props.px),
        width: props.orientation !== 'vertical' && "calc(100% - ".concat(spacing(props.shift || 0), ")") || props.width,
        height: props.orientation === 'vertical' && props.shift && "calc(100% - ".concat(spacing(props.shift), ")") || props.height
      };
    }
  };
});
/**
 * Divider.
 *
 * @function
 * @param {object} props
 * @param {'vertical' | 'horizontal'} [props.orientation='horizontal']
 * @param {number} [props.shift]
 * @param {number} [props.pt]
 * @param {number} [props.pb]
 * @param {number} [props.mt]
 * @param {number} [props.mb]
 * @param {number} [props.ml]
 * @param {number} [props.mr]
 * @param {number} [props.pl]
 * @param {number} [props.pr]
 * @param {number} [props.my]
 * @param {number} [props.mx]
 * @param {number} [props.px]
 * @param {number} [props.py]
 * @param {number} [props.m]
 * @param {number} [props.p]
 * @param {string} [props.color='']
 * @param {number} [props.height]
 * @param {number} [props.width]
 * @param props.className
 *
 * @returns {React.Element}
 *
 * @example
 * // TODO: Add example.
 */

var Divider = function Divider(_ref2) {
  var orientation = _ref2.orientation,
      shift = _ref2.shift,
      pt = _ref2.pt,
      pb = _ref2.pb,
      mt = _ref2.mt,
      mb = _ref2.mb,
      ml = _ref2.ml,
      mr = _ref2.mr,
      pl = _ref2.pl,
      pr = _ref2.pr,
      my = _ref2.my,
      mx = _ref2.mx,
      px = _ref2.px,
      py = _ref2.py,
      m = _ref2.m,
      p = _ref2.p,
      color = _ref2.color,
      height = _ref2.height,
      width = _ref2.width,
      className = _ref2.className,
      dividerProps = (0, _objectWithoutProperties2["default"])(_ref2, ["orientation", "shift", "pt", "pb", "mt", "mb", "ml", "mr", "pl", "pr", "my", "mx", "px", "py", "m", "p", "color", "height", "width", "className"]);
  var classes = useStyles({
    pt: pt,
    pb: pb,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    pl: pl,
    pr: pr,
    my: my,
    mx: mx,
    px: px,
    py: py,
    m: m,
    p: p,
    color: color,
    shift: shift,
    orientation: orientation,
    height: height,
    width: width
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Divider, (0, _extends2["default"])({}, dividerProps, {
    orientation: orientation,
    className: (0, _classnames["default"])(classes.divider, className)
  }));
};

exports.Divider = Divider;
Divider.propTypes = {
  pt: _propTypes["default"].number,
  pb: _propTypes["default"].number,
  mt: _propTypes["default"].number,
  mb: _propTypes["default"].number,
  ml: _propTypes["default"].number,
  mr: _propTypes["default"].number,
  pl: _propTypes["default"].number,
  pr: _propTypes["default"].number,
  my: _propTypes["default"].number,
  mx: _propTypes["default"].number,
  px: _propTypes["default"].number,
  py: _propTypes["default"].number,
  m: _propTypes["default"].number,
  p: _propTypes["default"].number,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  orientation: _propTypes["default"].oneOf(['vertical', 'horizontal']),
  shift: _propTypes["default"].number,
  className: _propTypes["default"].string
};
Divider.defaultProps = {
  pt: undefined,
  pb: undefined,
  mt: undefined,
  mb: undefined,
  my: undefined,
  mx: undefined,
  py: undefined,
  px: undefined,
  ml: undefined,
  mr: undefined,
  pl: undefined,
  pr: undefined,
  p: undefined,
  m: undefined,
  color: '',
  orientation: 'horizontal',
  shift: undefined,
  width: undefined,
  height: undefined,
  className: undefined
};
/**
 * @deprecated
 *
 * @type {Divider}
 */

var AlyceDivider = Divider;
exports.AlyceDivider = AlyceDivider;
var _default = Divider;
exports["default"] = _default;